import { yup } from '@guiker/shared-framework'

import { rentalFeeSchema } from '../prop-rentals/schemas/rental-fee-schema'

export const leaseTypePayloadSchema = yup.object({
  newLease: rentalFeeSchema.required(),
  renewal: rentalFeeSchema.required(),
  sublease: rentalFeeSchema.required(),
})

export const upsertRentalOwnerPayload = yup.object({
  newLease: rentalFeeSchema.required(),
  renewal: rentalFeeSchema.required(),
  sublease: rentalFeeSchema.required(),
  contractId: yup.string().nullable(),
})
